module.exports = __webpack_public_path__ + "static/media/money-check-edit.a10a96b5.svg";